import { render, staticRenderFns } from "./ItemsListSortable.vue?vue&type=template&id=30076fd2&scoped=true"
import script from "./ItemsListSortable.vue?vue&type=script&lang=js"
export * from "./ItemsListSortable.vue?vue&type=script&lang=js"
import style0 from "./ItemsListSortable.vue?vue&type=style&index=0&id=30076fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30076fd2",
  null
  
)

export default component.exports